import { render } from "./App.vue?vue&type=template&id=acb4a6ec"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=acb4a6ec&lang=css"

import exportComponent from "/home/ubuntu/RNAseq_web/prime_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__